/**
 * Scroll-triggered entrance for [data-scroll-reveal] grids:
 * direct children `.resource-list__item` or `li.product-grid__item`.
 * Handles infinite scroll appends and dynamic sections (e.g. product recommendations).
 */

const ITEM_SELECTOR = ':scope > .resource-list__item, :scope > li.product-grid__item';

function isRevealItem(node) {
  if (!(node instanceof Element)) return false;
  return (
    node.matches?.('.resource-list__item, li.product-grid__item') ||
    Boolean(node.querySelector?.('.resource-list__item, li.product-grid__item'))
  );
}

function setupScrollReveal() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const roots = document.querySelectorAll('[data-scroll-reveal]:not([data-scroll-reveal-ready])');

  roots.forEach((root) => {
    root.setAttribute('data-scroll-reveal-ready', '');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          el.classList.add('scroll-reveal-item--visible');
          observer.unobserve(el);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -6% 0px',
        threshold: 0.08,
      },
    );

    const observeItems = () => {
      const items = root.querySelectorAll(ITEM_SELECTOR);
      items.forEach((el) => {
        if (el.dataset.srBound === '1') return;
        el.dataset.srBound = '1';
        if (reduceMotion) {
          el.classList.add('scroll-reveal-item--visible');
          return;
        }
        observer.observe(el);
      });
    };

    observeItems();

    if (!reduceMotion) {
      const mo = new MutationObserver((mutations) => {
        let relevant = false;
        for (const m of mutations) {
          for (const node of m.addedNodes) {
            if (isRevealItem(node)) {
              relevant = true;
              break;
            }
          }
          if (relevant) break;
        }
        if (relevant) observeItems();
      });
      mo.observe(root, { childList: true });
    }
  });
}

function boot() {
  setupScrollReveal();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

document.addEventListener('shopify:section:load', boot);

let mutationDebounce;
if (!window.__scrollRevealDomWatch) {
  window.__scrollRevealDomWatch = true;
  const mo = new MutationObserver(() => {
    clearTimeout(mutationDebounce);
    mutationDebounce = setTimeout(() => {
      if (document.querySelector('[data-scroll-reveal]:not([data-scroll-reveal-ready])')) {
        setupScrollReveal();
      }
    }, 100);
  });
  mo.observe(document.body, { childList: true, subtree: true });
}
